import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router'
import { Observable } from 'rxjs/Rx'
import { AuthenticationService } from '../../theme/shared'

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _authService: AuthenticationService
  ) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    // Check if session expired
    const user = this._authService.getCurrentUserCookie()
    if (user) return true
    return this.handleError(state)
  }
  private handleError(state: RouterStateSnapshot) {
    // this._authService.logout();
    this._router.navigate(['/login'], {
      queryParams: { returnUrl: state.url }
    })
    return false
  }
}
